import { useCallback, useMemo } from 'react';
import { getFocusedRouteNameFromRoute, type ParamListBase, type RouteProp } from '@react-navigation/native';

import { Popup, settingsLine } from '@helpers';
import { RESTRICTED_SIDEBAR_TABS } from '@config/tenantRestrictions';
import ChangeLanguageModal from '@components/settings/components/modules/changeLanguage';
import ChangeThemeModal from '@components/settings/components/modules/changeTheme';

interface UseManageSettingsLimitedParams {
  route: RouteProp<ParamListBase, string>;
}

export const useManageSettingsLimited = ({ route }: UseManageSettingsLimitedParams) => {
  const selectedTab = getFocusedRouteNameFromRoute(route) || 'Account';

  const limitedTabs = useMemo(
    () => settingsLine.filter((t: any) => (RESTRICTED_SIDEBAR_TABS as readonly string[]).includes(t.value)),
    [],
  );

  const toggleChangeLanguage = useCallback(() => {
    Popup({ Component: ChangeLanguageModal });
  }, []);

  const toggleChangeTheme = useCallback(() => {
    Popup({ Component: ChangeThemeModal });
  }, []);

  return { selectedTab, limitedTabs, toggleChangeLanguage, toggleChangeTheme };
};
